import React from 'react';
import {
  Container,
  Sombra,
  Card,
  Label,
  LabelInfo,
  Valor,
  ContTitle,
  ContInfo,
  ContCard,
  Title,
  TitlePage,
  ContCalendarTotal,
  ContCalendar,
  ContInfosTotal,
  ContCargaDesc,
  Subtitle,
  List,
  Peso,
  SubContainer,
  Toneladas,
} from './styles';
import { DatePicker, Progress } from 'antd';

import mask from '../../../utils/mask';
import Refresh from '../../../components/Refresh';
import iconentrega from '../../../assets/img/entrega.svg';
import iconcoleta from '../../../assets/img/coleta.svg';
import { loadRequestCargaDescarga } from '../../../store/ducks/cargaDescarga/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import Spin from '../../../components/Spin';
import moment from 'moment';
import { CALENDAR_LOCALE } from '../../../utils/calendar-locale';
import { RangePickerProps } from 'antd/lib/date-picker';
import DonutPlot from './DonutPlot';
import imageUrl from '../../../assets/img/fundo2.jpg';

const CargaDescarga: React.FC = () => {
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const loading = useSelector((state: ApplicationState) => state.CargaDescarga.loading);
  const data = useSelector((state: ApplicationState) => state.CargaDescarga.data);
  const dataTotal = useSelector((state: ApplicationState) => state.CargaDescarga.dataTotal);

  const [dateRange, setDateRange] = React.useState<[moment.Moment, moment.Moment] | null>([
    moment().startOf('day'),
    moment().endOf('day'),
  ]);

  const {
    cargas,
    cargasConcluida,
    cargaPerc,
    descarga,
    descargaConcluida,
    descargaPerc,
    pesoCargas,
    pesoDescargas,
  } = dataTotal;

  React.useEffect(() => {
    dispatch(
      loadRequestCargaDescarga(moment().startOf('day').format(), moment().endOf('day').format())
    );
  }, [dispatch]);

  const handleChange: RangePickerProps['onChange'] = (date) => {
    if (date) {
      const initialDate = date && moment(date[0]).startOf('day').format();
      const finalDate = date && moment(date[1]).endOf('day').format();
      setDateRange([moment(date[0]), moment(date[1])]);
      dispatch(loadRequestCargaDescarga(initialDate, finalDate));
    } else {
      dispatch(
        loadRequestCargaDescarga(moment().startOf('day').format(), moment().endOf('day').format())
      );
    }
  };

  return (
    <Container
      style={{
        background: `url(${imageUrl}) no-repeat center center fixed`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    >
      <Sombra>
        <SubContainer>
          <Refresh
            loadRequest={() => {
              dispatch(
                loadRequestCargaDescarga(
                  moment().startOf('day').format(),
                  moment().endOf('day').format()
                )
              );
              setDateRange([moment().startOf('day'), moment().endOf('day')]); // Limpar o RangePicker
            }}
          />

          <TitlePage>Movimentação CDs Kothe (IN e OUT)</TitlePage>
          {loading ? (
            <div
              style={{
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Spin color=" #c5f0ff" />
              <h2 style={{ color: '#c5f0ff' }}>Carregando</h2>
            </div>
          ) : (
            <>
              <ContCalendarTotal>
                <ContCalendar>
                  <RangePicker
                    clearIcon={false}
                    allowEmpty={[false, false]}
                    onChange={handleChange}
                    format={CALENDAR_LOCALE.dateFormat}
                    value={dateRange}
                  />
                </ContCalendar>

                <ContInfosTotal>
                  <ContCargaDesc>
                    <div className="infos">
                      <div>
                        <Subtitle>Expedição</Subtitle>
                        <Toneladas> {mask('pesoTonelada', pesoCargas || '0')}</Toneladas>
                      </div>

                      <>
                        <List>
                          <li>
                            {' '}
                            <div>{cargas}</div> expedições
                          </li>
                          <li>
                            {' '}
                            <div>{cargasConcluida ?? 0}</div> Concluídas
                          </li>
                          <li>
                            {' '}
                            <div>{cargas - cargasConcluida ?? 0}</div> restantes
                          </li>
                        </List>
                      </>
                    </div>

                    <div className="contGrap">
                      <DonutPlot
                        data={[
                          {
                            type: 'concluídas',
                            value: cargasConcluida ?? 0,
                          },
                          {
                            type: 'restantes',
                            value: cargas - cargasConcluida ?? 0,
                          },
                        ]}
                        total={cargaPerc ?? 0}
                      />
                    </div>
                  </ContCargaDesc>

                  <ContCargaDesc>
                    <div className="infos">
                      <div>
                        <Subtitle>Recebimento</Subtitle>
                        <Toneladas> {mask('pesoTonelada', pesoDescargas || '0')}</Toneladas>
                      </div>

                      <>
                        <List>
                          <li>
                            <div>{descarga}</div> Recebimentos
                          </li>
                          <li>
                            <div>{descargaConcluida}</div> Concluídas
                          </li>
                          <li>
                            {' '}
                            <div>{descarga - descargaConcluida ?? 0}</div> restantes
                          </li>
                        </List>
                      </>
                    </div>
                    <div className="contGrap">
                      <DonutPlot
                        data={[
                          {
                            type: 'concluídos',
                            value: descargaConcluida ?? 0,
                          },
                          {
                            type: 'restantes',
                            value: descarga - descargaConcluida ?? 0,
                          },
                        ]}
                        total={descargaPerc ?? 0}
                      />
                    </div>
                  </ContCargaDesc>
                </ContInfosTotal>
              </ContCalendarTotal>

              <ContCard>
                {data.map((item) => {
                  const {
                    centroDistribuicao,
                    cargas,
                    descarga,
                    cargasConcluida,
                    descargaConcluida,
                    descargaPerc,
                    cargaPerc,
                    pesoCarga,
                    pesoDescarga,
                    pesoPendenteCarga,
                    pesoPendenteDescarga,
                  } = item;

                  return (
                    <Card>
                      <Title>{mask('camelCase', centroDistribuicao)}</Title>
                      <ContTitle>
                        <Label>
                          <img
                            src={iconcoleta}
                            alt="ícone de coleta"
                            style={{ marginRight: '5px' }}
                          />
                          <Valor>
                            {cargas} Expedições
                            <Peso>
                              <span>{mask('pesoTonelada', pesoCarga || '0')}</span>
                            </Peso>
                          </Valor>
                        </Label>

                        <Label>
                          <img
                            src={iconentrega}
                            alt="ícone de entrega"
                            style={{ marginRight: '5px' }}
                          />
                          <Valor>
                            {descarga} Recebimentos
                            <Peso>
                              <span>{mask('pesoTonelada', pesoDescarga || '0')}</span>
                            </Peso>
                          </Valor>
                        </Label>
                      </ContTitle>

                      <ContInfo>
                        <LabelInfo>
                          <p>
                            {cargasConcluida} expedições de {cargas}
                          </p>
                          <Peso>
                            <small>
                              {mask('pesoTonelada', pesoPendenteCarga || '0')} restantes
                            </small>
                          </Peso>

                          <div>
                            <Progress
                              type="circle"
                              percent={cargaPerc}
                              format={(percent) => `${percent}%`}
                              width={75}
                            />
                          </div>
                        </LabelInfo>

                        <LabelInfo>
                          <p>
                            {descargaConcluida} recebimentos de {descarga}
                          </p>
                          <Peso>
                            <small>
                              {mask('pesoTonelada', pesoPendenteDescarga || '0')} restantes
                            </small>
                          </Peso>

                          <div>
                            <Progress
                              type="circle"
                              percent={descargaPerc}
                              format={(percent) => `${percent}%`}
                              width={75}
                            />
                          </div>
                        </LabelInfo>
                      </ContInfo>
                    </Card>
                  );
                })}
              </ContCard>
            </>
          )}
        </SubContainer>
      </Sombra>
    </Container>
  );
};

export default CargaDescarga;
